export default __webpack_public_path__ + "static/media/edit.7f3631b2.svg";